import React from 'react';
import {
  FormGroup,
  HelpBlock,
} from 'react-bootstrap';

const FormFieldLayout = ({
  children,
  validationIcon,
  validationMessage,
  ...props
}) => (
  <FormGroup {...props}>
    <div
      style={{
        display: 'flex',
        padding: '0',
        justifyContent: 'center',
      }}
    >
      {children}
    </div>
    <HelpBlock style={{textAlign: 'center'}}>{validationMessage}</HelpBlock>
  </FormGroup>
);

export default FormFieldLayout;